import { computed, type ComputedRef } from 'vue'
import { storeToRefs } from 'pinia'
import { useAcessoStore } from '@next/compartilhados/acesso'

import { criarContextoDeCatalogo } from './catalogo.chave'
import type { ContextoDeCatalogo } from './catalogo.tipos'

export const usarContextoCatalogo = (): ComputedRef<ContextoDeCatalogo | null> => {
  const acesso = storeToRefs(useAcessoStore())

  return computed(() => criarContextoDeCatalogo({
    statusUsuario: acesso.statusUsuario.value,
    usuario: acesso.usuario.value,
    empresa: acesso.empresa.value,
    perfilAtivo: acesso.perfilAtivo.value,
    permissoes: acesso.permissoes.value,
  }))
}
